import { UPDATE_CHURN_SURVEY } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

const initialState = {
  parentValue: null,
  parentLabel: null,
  childValue: null,
  childLabel: null,
  other: null,
  timestamp: null,
  surveyComplete: false,
  isShowingChurnModal: false
}

const surveyReducer = createSettingsReducer(UPDATE_CHURN_SURVEY, initialState)

export default (state = {}, { type, payload }) => {
  if (type === UPDATE_CHURN_SURVEY) {
    return {
      ...state,
      [payload.key]: surveyReducer(state[payload.key], { type, payload: payload.data })
    }
  }
  return state
}



// WEBPACK FOOTER //
// ./reducers/application/churn-survey.js